import { authAction } from '../actionType';


export const userReducer = (state, action) => {
    switch (action.type) {
        case authAction.SAVE_USER:
            return {
                user: action.payload,
            };
        case authAction.REMOVE_USER:
            return {
                user: null
            };
        default:
            return state;
    }
}